module.exports = __webpack_public_path__ + "static/media/guns-and-bottles.281c3ea2.jpg";